// extracted by mini-css-extract-plugin
export default {"heading":"AuthHeader_heading__Nnyyz","logo":"AuthHeader_logo__3pArq","text":"AuthHeader_text__HcNVR"};